// The home timezone and the About panel.

import type { AboutInfo } from "@/platform/http";
import { api } from "@/platform/client";
import { qk } from "@/platform/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useDisplayTimezone() {
  return useQuery({
    queryKey: qk.settings.displayTimezone,
    queryFn: () => api.get<{ timezone: string }>("/settings/display-timezone"),
  });
}

export function useUpdateDisplayTimezone() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (timezone: string) =>
      api.put<{ timezone: string }>("/settings/display-timezone", { timezone }),
    // Every day the server reads is the home zone's.
    onSuccess: () => qc.invalidateQueries(),
  });
}

// Version/commit only change on redeploy or restart, never within a session.
export function useAbout() {
  return useQuery({
    queryKey: qk.settings.about,
    queryFn: () => api.get<AboutInfo>("/settings/about"),
    staleTime: Infinity,
  });
}
